import { useEffect, useState } from "react";
import { Input } from "@component/input";
import { SearchIcon } from "lucide-react";
import { SectionHeader } from "@component/section-header";
import { HireResponse } from "@type/contract";
import { getMyHires } from "@service/contract";
import CandidateHireItem from "@component/candidate-hire-item";
import LoadingBox from "@component/loading-box";

export function HiredCandidates() {
  const [activeTab, setActiveTab] = useState("all");
  const [isLoading, setLoading] = useState<boolean>(true);
  const [hiredCandidates, setHiredCandidates] = useState<HireResponse[]>([])

  useEffect(() => {
    getMyHires().then((res) => {
      setHiredCandidates(res)
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    })
  }, [])

  useEffect(() => {
    let status = activeTab;
    if (status === "all") {
      status = "";
    }

    setLoading(true);
    getMyHires(status).then((res) => {
      setHiredCandidates(res)
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    })

  }, [activeTab])

  return (
    <div className="space-y-6">
      <SectionHeader
        title="Hired Candidates"
        subtitle="Manage onboarding and active employees"
      />

      <div className="flex flex-col sm:flex-row">
        <div className="relative flex-1">
          <SearchIcon
            className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400"
          />
          <Input
            className="pl-9 w-full"
            placeholder="Search by name, position, or department..."
          />
        </div>
      </div>
      <div className="flex space-x-1 rounded-lg bg-gray-100 dark:bg-gray-800 p-1">
        <button
          onClick={() => setActiveTab("all")}
          className={`flex-1 py-2 px-3 rounded-md text-sm font-medium ${activeTab === "all"
            ? "bg-white dark:bg-gray-700 shadow-sm"
            : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            }`}
        >
          All Employees
        </button>
        <button
          onClick={() => setActiveTab("Active")}
          className={`flex-1 py-2 px-3 rounded-md text-sm font-medium ${activeTab === "Active"
            ? "bg-white dark:bg-gray-700 shadow-sm"
            : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            }`}
        >
          Active
        </button>
        <button
          onClick={() => setActiveTab("Pending Start")}
          className={`flex-1 py-2 px-3 rounded-md text-sm font-medium ${activeTab === "Pending Start"
            ? "bg-white dark:bg-gray-700 shadow-sm"
            : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            }`}
        >
          Pending Start
        </button>
      </div>

      {isLoading ? (
        <LoadingBox />
      ) : hiredCandidates.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {hiredCandidates.map((candidate, index) => (
            <CandidateHireItem key={index} candidate={candidate} />
          ))}
        </div>
      )}
    </div>
  );
}
